import { RestSlice } from '../../../../redux/rest.slice';
import { CccTechnician } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const cccTechnicianSlice = new RestSlice<CccTechnician>(
	localizationService.getLocalizedString('cccTechnician.technicians'),
	Resource.CccTechnicians
);
export default cccTechnicianSlice.rests.reducer;
